import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

// Response schema for GET /amzonboarding/
// Note: For Walmart/Shopify orgs, the backend only returns { org_status, remainder_days }
// so all Amazon-specific fields must be optional
const amazonOnboardingStatusSchema = z.object({
  amazon_advertising_access: z.string().optional(),
  amazon_additional_information: z.string().optional(),
  amazon_mws_access: z.string().optional(),
  last_product_status: z.string().optional(),
  about_your_company: z.string().optional(),
  payment_discovery: z.string().optional(),
  listings_progress: z.string().optional(),
  category_progress: z.string().optional(),
  stock_progress: z.string().optional(),
  eu_amazon_mws_access: z.string().optional(),
  fe_amazon_mws_access: z.string().optional(),
  visited_category_management: z.boolean().optional(),
  amazon_spapi_access: z.string().optional(),
  eu_amazon_spapi_access: z.string().optional(),
  fe_amazon_spapi_access: z.string().optional(),
  org_status: z.string(),
  remainder_days: z.number().nullable().optional(),
});

export type AmazonOnboardingStatus = z.infer<typeof amazonOnboardingStatusSchema>;

export const amazonOnboardingApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getAmazonOnboardingStatus",
    method: "get",
    path: "/amzonboarding/",
    status: 200,
    response: amazonOnboardingStatusSchema,
  }).build(),
);
